import app from 'firebase/app';
import 'firebase/analytics';


const firebaseConfig = {
  apiKey: "AIzaSyD4yNbDzs1H0edjXUkq2vFS_xtSePE_6yo",
  authDomain: "flexbox-test-c31bf.firebaseapp.com",
  databaseURL: "https://flexbox-test-c31bf.firebaseio.com",
  projectId: "flexbox-test-c31bf",
  storageBucket: "flexbox-test-c31bf.appspot.com",
  messagingSenderId: "462813664536",
  appId: "1:462813664536:web:a9227f4b8f7e441d503a6d",
  measurementId: "G-1J917YRKRN"
};


class Firebase {
  constructor(){
    app.initializeApp(firebaseConfig);
    this.analytics = app.analytics();
  }


}

export default Firebase;